export const EMAIL = 'email';
export const PASSWORD = 'password';
export const CONFIRM_PASSWORD = 'confirmPassword';
export const NAME = 'name';
export const PHONE_NUMBER = 'phoneNumber';

export const THEME = 'theme';
